import { createNetworkStatusNotifier } from 'react-apollo-network-status';
const { link, useApolloNetworkStatus } = createNetworkStatusNotifier();
export { link, useApolloNetworkStatus };
//# sourceMappingURL=NetworkStatusNotifier.js.map